(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beadifique-home-opening"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-bq-department]');
    if (!link) return;
    const findDepartment = () => [...document.querySelectorAll('[data-ibead-menu] [data-department]')].find(button => button.textContent.trim() === link.dataset.bqDepartment);
    const department = findDepartment();
    if (!department) return;
    if (window.matchMedia('(min-width: 1025px)').matches) {
      const trigger = document.querySelector('[data-ibead-toggle]');
      if (!trigger) return;
      event.preventDefault();
      event.stopPropagation();
      trigger.scrollIntoView({ block: 'nearest' });
      if (trigger.getAttribute('aria-expanded') !== 'true') trigger.click();
      department.click();
      department.focus({ preventScroll: true });
    } else {
      const trigger = [...document.querySelectorAll('.mobileMenu-toggle')].find(button => button.getClientRects().length);
      if (!trigger) return;
      event.preventDefault();
      event.stopPropagation();
      if (!document.body.classList.contains('menu_open')) trigger.click();
      requestAnimationFrame(() => requestAnimationFrame(() => findDepartment()?.click()));
    }
  }, { capture: true });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active')?.classList.remove('active');
            this.tabContent.querySelector('.active')?.classList.remove('active');
            this.querySelector(e.currentTarget.dataset.target)?.classList.add('active');
            e.currentTarget.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.currentTarget.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.currentTarget.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.currentTarget.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.currentTarget.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.currentTarget.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.currentTarget.querySelector('span').textContent = e.currentTarget.dataset.buttonmore;
                    e.currentTarget.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.currentTarget.querySelector('span').textContent = e.currentTarget.dataset.buttonless;
                    e.currentTarget.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"]) return;
  try {
    
    class StickyHeaderMobile extends HTMLElement {
        constructor() {
            super();
        }
  
        connectedCallback() {
            this.header = document.querySelector('.section-header-mobile');
            this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
            this.headerBounds = {};
    
            if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
            };
    
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');
    
            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    
            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
    
            this.createObserver();
        }
  
        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }
  
        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
    
            observer.observe(this.header);
        }
  
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    
            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (this.preventHide) return;
                requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);
        
                    this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                    }, 66);
        
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }
    
            this.currentScrollTop = scrollTop;
        }
  
        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.header.style.top = '';
        }
  
        reveal() {
            const headerMultiSite = document.querySelector('.section-header-nav-multi-site');
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            if (headerMultiSite) {
                const height = headerMultiSite.offsetHeight;
                this.header.style.top = `${height}px`;
            }
        }
  
        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            this.header.style.top = '';
        }
    }
  
    customElements.define('sticky-header-mobile', StickyHeaderMobile);

    document.querySelector('[data-mobile-menu]')?.addEventListener('click', () => {
        document.body.classList.toggle('menu_open');
    })

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };

    function renderLogoMobile() {
        if ($("[data-menu-tab]").length > 0) {

            $(document).on("click", "[data-menu-tab] li", (event) => {
                var active = $(event.currentTarget).data("load-page"),
                    href = $(event.currentTarget).attr("href");

                $.cookie("page-url", active, {
                    expires: 1,
                    path: "/",
                });
            });

            var canonical = $("[canonical-shop-url]").attr("canonical-shop-url"),
            pageUrl = $.cookie("page-url"),
            menuTabItem,
            logoTabItem,
            menuItem;

            if (
                window.location.pathname.indexOf("/pages/") !== -1 &&
                window.page_active &&
                window.page_active != pageUrl
            ) {
                setCookie("page-url", window.page_active, 1);
                pageUrl = window.page_active;
            }
            
            if (pageUrl != null) {
                menuTabItem = $(`[data-load-page="${pageUrl}"]`);
                logoTabItem = $(`[data-load-logo-page="${pageUrl}"]`);
                menuItem = $(`[data-load-menu-page="${pageUrl}"]`);
            } else {
                menuTabItem = $("[data-load-page].is-active");
                logoTabItem = $("[data-load-logo-page].first");
                menuItem = $("[data-load-menu-page].is-active");
            }

            var menuTab = menuTabItem.closest("[data-menu-tab]");

            menuTab
                .find("[data-load-page]")
                .not(menuTabItem)
                .removeClass("is-active");
                logoTabItem.siblings().removeClass("is-active");
                menuItem.siblings().removeClass("is-active");
            if (pageUrl != "") {
                logoTabItem.addClass("is-active");
                menuTabItem.addClass("is-active");
                menuItem.addClass("is-active");
            } else {
                $("[data-load-page]:nth-child(1)").addClass("is-active");
                $("[data-load-logo-page]:nth-child(1)").addClass("is-active");
                $("[data-load-menu-page]:nth-child(1)").addClass("is-active");
            }

            const header = menuTabItem.closest(".header");

            
            if (header && window.innerWidth < 1025) {
                if (
                    window.location.pathname.indexOf("/pages/") !== -1 &&
                    window.page_active &&
                    window.page_active != pageUrl
                ) {
                    setCookie("page-url", window.page_active, 1);
                    pageUrl = window.page_active;
                }

                const logoMobile = $(".header-mobile .header__heading-link");
                const logDesktop = header.find(".header__heading-link.is-active");

                if (logDesktop.data("logo-mobile") == undefined) {
                    logoMobile.find("img").addClass("logo-show");
                    return;
                } else {
                    logoMobile.html(
                    `<img src="${logDesktop.data(
                        "logo-mobile"
                    )}" alt="${logDesktop.data(
                        "logo-mobile-alt"
                    )}" style="max-width: ${logoMobile.data(
                        "logo-width"
                    )}px; height: auto"/>`
                    );

                    logoMobile.find("img").addClass("logo-show");
                    if (pageUrl != "" && pageUrl != null)
                    logoMobile.attr("href", pageUrl);
                }
            }
        }
    }

    window.haloVendorReady(renderLogoMobile);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sticky-header-multi-site')) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          if (!this.querySelector('.header-nav-multi-site')) return;
          this.header = this.closest('.shopify-section');
          if (!this.header) return;
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          this.headerMediaQuery = window.matchMedia('(max-width: 990px)');
          this.boundHeaderHeight = this.boundHeaderHeight || this.setHeaderHeight.bind(this);
          this.headerMediaQuery.addEventListener('change', this.boundHeaderHeight);
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
          this.headerMediaQuery?.removeEventListener('change', this.boundHeaderHeight);
          this.headerObserver?.disconnect();
          clearTimeout(this.isScrolling);
          cancelAnimationFrame(this.headerFrame);
        }

        createObserver() {
          const observer = this.headerObserver = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            this.headerFrame = requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              this.headerFrame = requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              this.headerFrame = requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            this.headerFrame = requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    if (!customElements.get('sticky-header-multi-site')) customElements.define('sticky-header-multi-site', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-basic"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sticky-header-basic')) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          if (!this.querySelector('.header-nav-basic')) return;
          this.header = this.closest('.shopify-section');
          if (!this.header) return;
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          this.headerMediaQuery = window.matchMedia('(max-width: 990px)');
          this.boundHeaderHeight = this.boundHeaderHeight || this.setHeaderHeight.bind(this);
          this.headerMediaQuery.addEventListener('change', this.boundHeaderHeight);

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
          this.headerMediaQuery?.removeEventListener('change', this.boundHeaderHeight);
          this.headerObserver?.disconnect();
          clearTimeout(this.isScrolling);
          cancelAnimationFrame(this.headerFrame);
        }

        createObserver() {
          const observer = this.headerObserver = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            this.headerFrame = requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              this.headerFrame = requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              this.headerFrame = requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            this.headerFrame = requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    if (!customElements.get('sticky-header-basic')) customElements.define('sticky-header-basic', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-compact"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sticky-header-compact')) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          if (!this.querySelector('.header-nav-compact')) return;
          this.header = this.closest('.shopify-section');
          if (!this.header) return;
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          this.headerMediaQuery = window.matchMedia('(max-width: 990px)');
          this.boundHeaderHeight = this.boundHeaderHeight || this.setHeaderHeight.bind(this);
          this.headerMediaQuery.addEventListener('change', this.boundHeaderHeight);

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
          this.headerMediaQuery?.removeEventListener('change', this.boundHeaderHeight);
          this.headerObserver?.disconnect();
          clearTimeout(this.isScrolling);
          cancelAnimationFrame(this.headerFrame);
        }

        createObserver() {
          const observer = this.headerObserver = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            this.headerFrame = requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              this.headerFrame = requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              this.headerFrame = requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            this.headerFrame = requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    if (!customElements.get('sticky-header-compact')) customElements.define('sticky-header-compact', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-full-elements"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sticky-header-full-elements')) {

    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (!this.querySelector('.header-nav-full-elements')) return;
          this.header = this.closest('.shopify-section');
          if (!this.header) return;
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      this.headerMediaQuery = window.matchMedia('(max-width: 990px)');
          this.boundHeaderHeight = this.boundHeaderHeight || this.setHeaderHeight.bind(this);
          this.headerMediaQuery.addEventListener('change', this.boundHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
          this.headerMediaQuery?.removeEventListener('change', this.boundHeaderHeight);
          this.headerObserver?.disconnect();
          clearTimeout(this.isScrolling);
          cancelAnimationFrame(this.headerFrame);
    }

    createObserver() {
      const observer = this.headerObserver = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        this.headerFrame = requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          this.headerFrame = requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          this.headerFrame = requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.headerFrame = requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  if (!customElements.get('sticky-header-full-elements')) customElements.define('sticky-header-full-elements', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-hamburger"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sticky-header-hamburger')) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          if (!this.querySelector('.header-nav-hamburger')) return;
          this.header = this.closest('.shopify-section');
          if (!this.header) return;
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          this.headerMediaQuery = window.matchMedia('(max-width: 990px)');
          this.boundHeaderHeight = this.boundHeaderHeight || this.setHeaderHeight.bind(this);
          this.headerMediaQuery.addEventListener('change', this.boundHeaderHeight);
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          this.boundLoadPosition = this.boundLoadPosition || this.checkLoadPosition.bind(this);
          if (document.readyState === 'complete') this.boundLoadPosition();
          else window.addEventListener('load', this.boundLoadPosition);
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }
        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }
        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('load', this.boundLoadPosition);
          window.removeEventListener('scroll', this.onScrollHandler);
          this.headerMediaQuery?.removeEventListener('change', this.boundHeaderHeight);
          this.headerObserver?.disconnect();
          clearTimeout(this.isScrolling);
          cancelAnimationFrame(this.headerFrame);
        }
        createObserver() {
          const observer = this.headerObserver = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }
        checkLoadPosition() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const headerGr = document.querySelectorAll(".shopify-section-group-header-group");

            if(headerGr[0]?.classList.contains('shopify-section-header-sticky')) {
                if(scrollTop > headerGr[0].offsetHeight && !this.header.classList.contains('scrolled-past-header')) {
                    this.header.classList.add('shopify-section-header-hidden');
                }
            } else {
                headerGr.forEach(item => {
                    if(item.classList.contains('shopify-section-header-sticky') ) {
                        const itemPrev = item.previousElementSibling;
                        if (!itemPrev) return;
                        const itemPrevHeight = itemPrev.offsetHeight;
                        const itemPrevTop = itemPrev.offsetTop;

                        if(scrollTop > itemPrevTop + itemPrevHeight && !this.header.classList.contains('scrolled-past-header')) {
                            this.header.classList.add('shopify-section-header-hidden');
                        }
                    }
                });
            }
        }
        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            this.headerFrame = requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              this.headerFrame = requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              this.headerFrame = requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            this.headerFrame = requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }
        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                    document.querySelector('body').classList.add("section-header-is-hidden")
                }
            }
          this.closeMenuDisclosure();
        }
        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    if (!customElements.get('sticky-header-hamburger')) customElements.define('sticky-header-hamburger', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-left-aligned"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sticky-header-left-aligned')) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          if (!this.querySelector('.header-nav-left-aligned')) return;
          this.header = this.closest('.shopify-section');
          if (!this.header) return;
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          this.headerMediaQuery = window.matchMedia('(max-width: 990px)');
          this.boundHeaderHeight = this.boundHeaderHeight || this.setHeaderHeight.bind(this);
          this.headerMediaQuery.addEventListener('change', this.boundHeaderHeight);

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
          this.headerMediaQuery?.removeEventListener('change', this.boundHeaderHeight);
          this.headerObserver?.disconnect();
          clearTimeout(this.isScrolling);
          cancelAnimationFrame(this.headerFrame);
        }

        createObserver() {
          const observer = this.headerObserver = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            this.headerFrame = requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              this.headerFrame = requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              this.headerFrame = requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            this.headerFrame = requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    if (!customElements.get('sticky-header-left-aligned')) customElements.define('sticky-header-left-aligned', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-plain"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sticky-header-plain')) {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (!this.querySelector('.header-nav-plain')) return;
          this.header = this.closest('.shopify-section');
          if (!this.header) return;
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      this.headerMediaQuery = window.matchMedia('(max-width: 990px)');
          this.boundHeaderHeight = this.boundHeaderHeight || this.setHeaderHeight.bind(this);
          this.headerMediaQuery.addEventListener('change', this.boundHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
          this.headerMediaQuery?.removeEventListener('change', this.boundHeaderHeight);
          this.headerObserver?.disconnect();
          clearTimeout(this.isScrolling);
          cancelAnimationFrame(this.headerFrame);
    }

    createObserver() {
      const observer = this.headerObserver = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');
        this.headerFrame = requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');

        if (!this.preventReveal) {
          this.headerFrame = requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          this.headerFrame = requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.body.classList.remove('scrolled-header');
        this.headerFrame = requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  if (!customElements.get('sticky-header-plain')) customElements.define('sticky-header-plain', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-utility"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sticky-header-utility')) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          if (!this.querySelector('.header-nav-utility')) return;
          this.header = this.closest('.shopify-section');
          if (!this.header) return;
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          this.headerMediaQuery = window.matchMedia('(max-width: 990px)');
          this.boundHeaderHeight = this.boundHeaderHeight || this.setHeaderHeight.bind(this);
          this.headerMediaQuery.addEventListener('change', this.boundHeaderHeight);

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
          this.headerMediaQuery?.removeEventListener('change', this.boundHeaderHeight);
          this.headerObserver?.disconnect();
          clearTimeout(this.isScrolling);
          cancelAnimationFrame(this.headerFrame);
        }

        createObserver() {
          const observer = this.headerObserver = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            this.headerFrame = requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              this.headerFrame = requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              this.headerFrame = requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            this.headerFrame = requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    if (!customElements.get('sticky-header-utility')) customElements.define('sticky-header-utility', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-vertical-menu"] && !Shopify.designMode) return;
  try {
    
    window.haloVendorReady(function() {
if (!customElements.get('sticky-header-vertical-menu')) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          if (!this.querySelector('.header-nav-vertical-menu')) return;
          this.header = this.closest('.shopify-section');
          if (!this.header) return;
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          this.headerMediaQuery = window.matchMedia('(max-width: 990px)');
          this.boundHeaderHeight = this.boundHeaderHeight || this.setHeaderHeight.bind(this);
          this.headerMediaQuery.addEventListener('change', this.boundHeaderHeight);

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
          this.headerMediaQuery?.removeEventListener('change', this.boundHeaderHeight);
          this.headerObserver?.disconnect();
          clearTimeout(this.isScrolling);
          cancelAnimationFrame(this.headerFrame);
        }

        createObserver() {
          const observer = this.headerObserver = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            this.headerFrame = requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              this.headerFrame = requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              this.headerFrame = requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            this.headerFrame = requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
                if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                    $('.vertical-menu').addClass('vertical-menu__hide');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
              if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                  if (document.body.classList.contains('template-index')) {
                      if ($('.vertical-menu').hasClass('vertical-menu__hide')) {
                          $('.vertical-menu').removeClass('vertical-menu__hide');
                      }
                  }
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  if (!customElements.get('sticky-header-vertical-menu')) customElements.define('sticky-header-vertical-menu', StickyHeader);
}

    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shiphub-order-tracking"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shiphub-order-tracking')) {
    customElements.define('shiphub-order-tracking', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.strings = JSON.parse(this.querySelector('[data-tracking-strings]').textContent);
        this.form = this.querySelector('form');
        this.button = this.querySelector('button[type="submit"]');
        this.feedback = this.querySelector('[data-feedback]');
        this.results = this.querySelector('[data-results]');
        this.locale = this.dataset.locale || 'en-CA';
        this.account = this.dataset.account === 'true';
        this.customer = this.dataset.customer || '';
        this.storageKey = 'shiphub:order-tracking:v1:' + window.location.pathname;
        this.modeToggle = this.querySelector('[data-mode-toggle]');
        this.sequence = 0;
        this.blockedUntil = 0;
        this.button.disabled = false;
        this.listeners = new AbortController();
        this.form.addEventListener('submit', event => this.submit(event), { signal: this.listeners.signal });
        this.form.addEventListener('input', () => this.clear(), { signal: this.listeners.signal });
        window.addEventListener('pagehide', () => { this.clear(false); this.form.reset(); }, { signal: this.listeners.signal });
        if (this.modeToggle) {
          this.modeToggle.hidden = false;
          this.modeToggle.addEventListener('click', () => this.setAccountMode(!this.account), { signal: this.listeners.signal });
        }
        if (!this.restoreLookup()) this.openLinkedOrder();
      }

      disconnectedCallback() {
        this.sequence += 1;
        this.controller?.abort();
        clearTimeout(this.retryTimer);
        this.listeners?.abort();
        this.initialized = false;
      }

      text(key) { return this.strings[key] || ''; }

      forgetLookup() {
        try { sessionStorage.removeItem(this.storageKey); } catch {}
      }

      rememberLookup(orderNumber, email, account) {
        try {
          sessionStorage.setItem(this.storageKey, JSON.stringify({
            customer: this.customer,
            orderNumber,
            email: account ? '' : email,
            account
          }));
        } catch {}
      }

      restoreLookup() {
        let saved;
        try {
          if (performance.getEntriesByType('navigation')[0]?.type !== 'reload') {
            this.forgetLookup();
            return false;
          }
          saved = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null');
        } catch {
          this.forgetLookup();
          return false;
        }
        if (!saved || saved.customer !== this.customer || typeof saved.account !== 'boolean' ||
            (saved.account && !this.account) || typeof saved.orderNumber !== 'string' ||
            !saved.orderNumber.trim() || saved.orderNumber.length > 64 || /[\x00-\x1f\x7f]/.test(saved.orderNumber) ||
            typeof saved.email !== 'string' || saved.email.length > 254) {
          this.forgetLookup();
          return false;
        }
        if (saved.account !== this.account) this.setAccountMode(saved.account);
        this.form.elements.orderNumber.value = saved.orderNumber;
        this.form.elements.email.value = saved.account ? '' : saved.email;
        if (!this.form.checkValidity()) {
          this.forgetLookup();
          this.form.reset();
          return false;
        }
        this.form.requestSubmit();
        return true;
      }

      setAccountMode(account) {
        this.clear();
        this.account = account;
        this.dataset.account = String(account);
        const email = this.form.elements.email;
        email.disabled = account;
        email.required = !account;
        email.value = '';
        this.querySelector('[data-email-field]').hidden = account;
        this.querySelector('[data-intro]').textContent = this.text(account ? 'account_intro' : 'intro');
        if (this.modeToggle) this.modeToggle.textContent = this.text(account ? 'use_email' : 'use_account');
        (account ? this.form.elements.orderNumber : email).focus({ preventScroll: true });
      }

      openLinkedOrder() {
        const fragment = new URLSearchParams(window.location.hash.slice(1));
        if (fragment.getAll('order').length !== 1) return;
        const orderNumber = fragment.get('order')?.trim();
        if (!orderNumber || orderNumber.length > 64 || /[\x00-\x1f\x7f]/.test(orderNumber)) return;
        this.form.elements.orderNumber.value = orderNumber;
        if (this.account) this.form.requestSubmit();
      }

      element(tag, className, text) {
        const node = document.createElement(tag);
        if (className) node.className = className;
        if (text !== undefined && text !== null) node.textContent = String(text);
        return node;
      }

      notice(message, error = false) {
        this.feedback.textContent = message;
        this.feedback.dataset.error = String(error);
      }

      clear(forget = true) {
        if (forget) this.forgetLookup();
        this.sequence += 1;
        this.controller?.abort();
        this.results.replaceChildren();
        this.results.removeAttribute('aria-busy');
        this.button.textContent = this.text('submit');
        this.button.disabled = Date.now() < this.blockedUntil;
        if (!this.button.disabled) this.notice('');
      }

      async submit(event) {
        event.preventDefault();
        if (Date.now() < this.blockedUntil || !this.form.reportValidity()) return;
        this.clear();
        const orderNumber = this.form.elements.orderNumber.value.trim();
        const email = this.form.elements.email.value.trim();
        const account = this.account;
        if (!orderNumber || (!account && !email)) { this.notice(this.text(account ? 'account_invalid' : 'invalid'), true); return; }
        const sequence = this.sequence;
        const controller = new AbortController();
        this.controller = controller;
        this.button.disabled = true;
        this.button.textContent = this.text('loading');
        this.results.setAttribute('aria-busy', 'true');
        this.notice(this.text('loading'));
        const timeout = setTimeout(() => controller.abort(), 20000);
        try {
          const response = await fetch('/apps/track-order', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(account ? { orderNumber, auth: 'customer' } : { orderNumber, email }),
            cache: 'no-store',
            credentials: 'same-origin',
            redirect: 'error',
            referrerPolicy: 'no-referrer',
            signal: controller.signal
          });
          const payload = response.headers.get('content-type')?.includes('application/json') ? await response.json() : null;
          if (sequence !== this.sequence) return;
          if (response.status === 429) {
            const header = response.headers.get('retry-after');
            const headerSeconds = header && /^\d+$/.test(header) ? Number(header) : header ? (Date.parse(header) - Date.now()) / 1000 : 0;
            const bodySeconds = Number(payload?.retryAfterSeconds);
            const seconds = Math.max(1, Number.isFinite(headerSeconds) && headerSeconds > 0 ? headerSeconds : Number.isFinite(bodySeconds) && bodySeconds > 0 ? bodySeconds : 60);
            this.blockedUntil = Date.now() + seconds * 1000;
            this.notice(this.text('limited').replace('[minutes]', String(Math.ceil(seconds / 60))), true);
            clearTimeout(this.retryTimer);
            this.retryTimer = setTimeout(() => {
              this.button.disabled = false;
              this.notice(this.text('ready'));
            }, Math.min(seconds * 1000, 2147483647));
          } else if (response.status === 401 && payload?.kind === 'login_required' && account) {
            this.setAccountMode(false);
            this.notice(this.text('login_required'), true);
          } else if (response.status === 404 && payload?.kind === 'not_found') {
            this.notice(this.text(account ? 'account_not_found' : 'not_found'), true);
          } else if (response.status === 400) {
            this.notice(this.text(account ? 'account_invalid' : 'invalid'), true);
          } else if (response.ok && payload?.kind === 'found') {
            this.render(payload);
            this.rememberLookup(orderNumber, email, account);
            this.notice('');
            this.results.querySelector('h2')?.focus({ preventScroll: true });
          } else {
            this.notice(this.text('unavailable'), true);
          }
        } catch {
          if (sequence === this.sequence) {
            this.results.replaceChildren();
            this.notice(this.text('unavailable'), true);
          }
        } finally {
          clearTimeout(timeout);
          if (sequence === this.sequence) {
            this.results.removeAttribute('aria-busy');
            this.button.textContent = this.text('submit');
            this.button.disabled = Date.now() < this.blockedUntil;
          }
        }
      }

      dateOnly(value) {
        if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
        const date = new Date(value + 'T12:00:00Z');
        return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value ? date : null;
      }

      orderDateTime(value) {
        if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}T.*Z$/.test(value)) return '';
        const date = new Date(value);
        return Number.isFinite(date.getTime()) ? new Intl.DateTimeFormat(this.locale, { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: 'America/Toronto', timeZoneName: 'short' }).formatToParts(date).map(part => part.type === 'timeZoneName' ? 'ET' : part.value).join('') : '';
      }

      moment(moment, compact = false) {
        if (!moment || typeof moment !== 'object') return '';
        const dateOptions = { year: 'numeric', month: 'short', day: 'numeric' };
        if (moment.kind === 'instant' && typeof moment.value === 'string') {
          const date = new Date(moment.value);
          if (!Number.isFinite(date.getTime()) || !/^\d{4}-\d{2}-\d{2}T.*Z$/.test(moment.value)) return '';
          return new Intl.DateTimeFormat(this.locale, { ...dateOptions, hour: 'numeric', minute: '2-digit', timeZone: 'America/Toronto', ...(compact ? {} : { timeZoneName: 'short' }) }).format(date);
        }
        if (moment.kind === 'date') {
          const date = this.dateOnly(moment.value);
          return date ? new Intl.DateTimeFormat(this.locale, { ...dateOptions, timeZone: 'UTC' }).format(date) : '';
        }
        if (moment.kind === 'local') {
          const date = this.dateOnly(moment.date);
          if (!date) return '';
          const label = new Intl.DateTimeFormat(this.locale, { ...dateOptions, timeZone: 'UTC' }).format(date);
          const time = typeof moment.time === 'string' && /^\d{2}:\d{2}(?::\d{2})?$/.test(moment.time) ? moment.time.slice(0, 5) : '';
          return label + (time ? ' · ' + time + ' (' + this.text('carrier_time') + ')' : '');
        }
        return '';
      }

      momentNode(moment, compact = false) {
        const label = this.moment(moment, compact);
        const node = this.element('time', '', label);
        if (label && (moment.kind === 'instant' || moment.kind === 'date')) node.dateTime = moment.value;
        return node;
      }

      tone(value) { return ['neutral', 'info', 'warning', 'success'].includes(value) ? value : 'neutral'; }

      icon(id) {
        const paths = {
          ordered: ['M2 3h3l3 12h11l2-8H6', 'M10.5 10.7l1.8 1.8 3.5-3.6', 'M10.5 19.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M19.5 19.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0'],
          label_created: ['M6 3h12a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z', 'M8 7h8M8 10h5', 'M8 14v3M11 14v3M14 14v3M17 14v3'],
          shipped: ['M3 7l9-4 9 4v10l-9 4-9-4z', 'M3 7l9 4 9-4M12 11v10'],
          in_transit: ['M3 17V5h11v12M3 17h2m4 0h7m4 0h1v-6l-3-4h-4', 'M14 11h7', 'M9 17a2 2 0 1 1-4 0 2 2 0 0 1 4 0M20 17a2 2 0 1 1-4 0 2 2 0 0 1 4 0'],
          delivered: ['M2 11l10-9 10 9M5 9v12h14V9', 'M8 13l3 3 5-5'],
          mailed: ['M3 5h18v14H3z', 'M3 6l9 7 9-7'],
          ready_for_pickup: ['M4 9h16v12H4zM3 3h18v6H3z', 'M9 21v-7h6v7'],
          picked_up: ['M8 12l3 3 5-6', 'M12 2a10 10 0 1 0 0 20 10 10 0 1 0 0-20']
        };
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        for (const [key, value] of Object.entries({ viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.7', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true', focusable: 'false' })) svg.setAttribute(key, value);
        for (const path of paths[id] || paths.ordered) {
          const child = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          child.setAttribute('d', path);
          svg.append(child);
        }
        return svg;
      }

      render(payload) {
        if (!payload.order || typeof payload.order.name !== 'string' || !Array.isArray(payload.shipments) || payload.shipments.length > 20) throw new Error();
        const fragment = document.createDocumentFragment();
        const header = this.element('div', 'sh-tracking__order');
        const title = this.element('h2', '', this.text('order_heading') + ' ' + payload.order.name);
        title.tabIndex = -1;
        header.append(title);
        const ordered = this.orderDateTime(payload.order.orderedAt);
        if (ordered) header.append(this.element('p', '', this.text('placed') + ' ' + ordered));
        const status = payload.order.status;
        const showStatus = status && typeof status.headline === 'string' && status.state !== 'fulfilled' &&
          (!payload.shipments.length || !['ordered', 'in_progress', 'unknown'].includes(status.state));
        if (showStatus) {
          const notice = this.element('div', 'sh-tracking__order-status');
          notice.dataset.tone = this.tone(status.tone);
          notice.append(this.element('strong', '', status.headline), this.element('p', '', status.message));
          header.append(notice);
        }
        fragment.append(header);
        for (const [index, card] of payload.shipments.entries()) fragment.append(this.card(card, index, payload.shipments.length));
        if (!payload.shipments.length && !showStatus) fragment.append(this.element('p', 'sh-tracking__notice', this.text('empty')));
        this.results.replaceChildren(fragment);
      }

      card(card, index, total) {
        if (!card || !card.status || !Array.isArray(card.trackingNumbers) || !Array.isArray(card.events) || !Array.isArray(card.milestones)) throw new Error();
        const article = this.element('article', 'sh-tracking__card');
        const top = this.element('div', 'sh-tracking__card-top');
        const method = this.text(card.method) || this.text('shipment');
        const eyebrow = this.element('p', 'sh-tracking__eyebrow', total > 1 ? this.text('shipment') + ' ' + (index + 1) + ' / ' + total + ' · ' + method : method);
        const row = this.element('div', 'sh-tracking__headline-row');
        const overview = this.element('div');
        const headline = this.element('h3', 'sh-tracking__headline', card.status.headline);
        headline.dataset.tone = this.tone(card.status.tone);
        overview.append(eyebrow, headline, this.element('p', 'sh-tracking__message', card.status.message));
        const service = [...new Set([card.carrier, card.serviceName].filter(value => typeof value === 'string' && value))].join(' · ');
        if (service) overview.append(this.element('p', 'sh-tracking__service', service));
        row.append(overview);
        const expected = this.moment(card.expectedDelivery);
        const expectedDay = card.expectedDelivery?.kind === 'local' ? card.expectedDelivery.date : card.expectedDelivery?.value?.slice(0, 10);
        const todayParts = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
        const today = ['year', 'month', 'day'].map(type => todayParts.find(part => part.type === type).value).join('-');
        if (expected && expectedDay >= today && card.availability === 'available' && card.progress?.currentStep !== 'delivered' && card.status.tone !== 'warning') {
          const estimate = this.element('div', 'sh-tracking__estimate', this.text('estimated'));
          estimate.append(this.element('strong', '', expected), this.element('p', '', this.text('estimate_note')));
          row.append(estimate);
        }
        top.append(row);
        if (card.availability === 'available' && card.progress && Array.isArray(card.progress.steps)) {
          const steps = this.element('ol', 'sh-tracking__steps');
          for (const step of card.progress.steps) {
            const item = this.element('li', 'sh-tracking__step');
            item.dataset.state = ['complete', 'current', 'upcoming'].includes(step.state) ? step.state : 'upcoming';
            if (step.id === card.progress.currentStep) item.setAttribute('aria-current', 'step');
            const circle = this.element('span', 'sh-tracking__step-icon');
            circle.append(this.icon(step.id));
            item.append(circle, this.element('span', '', step.label), this.element('span', 'sh-tracking__sr', ' — ' + this.text(item.dataset.state)));
            steps.append(item);
          }
          top.append(steps);
        }
        if (card.method === 'stamped_envelope') top.append(this.element('p', 'sh-tracking__envelope-note', this.text('envelope_help')));
        article.append(top);
        const bottom = this.element('div', 'sh-tracking__card-bottom');
        const history = this.element('details', 'sh-tracking__history');
        history.open = true;
        const summary = this.element('summary');
        summary.append(this.element('span', '', this.text('history')));
        if (card.events.length) summary.append(this.element('span', 'sh-tracking__history-count', this.text(card.events.length === 1 ? 'update_one' : 'update_many').replace('[count]', String(card.events.length))));
        history.append(summary);
        const events = this.element('ol', 'sh-tracking__events');
        for (const event of card.events) {
          const item = this.element('li', 'sh-tracking__event');
          item.append(this.momentNode(event.at, true), this.element('p', 'sh-tracking__event-description', event.description));
          if (event.location) item.append(this.element('p', 'sh-tracking__location', event.location));
          events.append(item);
        }
        history.append(events);
        if (card.events.some(event => event.at?.kind === 'instant' && this.moment(event.at))) {
          const hasLocalTime = card.events.some(event => event.at?.kind === 'local' && event.at.time && this.moment(event.at));
          history.append(this.element('p', 'sh-tracking__history-time', this.text(hasLocalTime ? 'history_mixed_time' : 'history_time')));
        }
        if (!card.events.length) history.append(this.element('p', 'sh-tracking__muted', ['stamped_envelope', 'store_pickup'].includes(card.method) ? card.status.message : this.text('no_history')));
        if (card.historyTruncated) history.append(this.element('p', 'sh-tracking__muted', this.text('truncated')));
        bottom.append(history);
        const details = this.element('div', 'sh-tracking__details');
        details.append(this.element('h3', '', this.text('details')));
        const numbers = this.element('ul', 'sh-tracking__numbers');
        for (const tracking of card.trackingNumbers) {
          const item = this.element('li', 'sh-tracking__number');
          item.append(this.element('strong', '', tracking.company || this.text('tracking_number')));
          const company = (tracking.company || card.carrier || '').trim().toLowerCase().replace(/\s+/g, ' ');
          if (['canada post', 'postes canada'].includes(company) && typeof tracking.number === 'string' && /^[a-zA-Z0-9]{8,35}$/.test(tracking.number)) {
            const link = this.element('a', '', tracking.number);
            link.href = 'https://www.canadapost-postescanada.ca/track-reperage/' + (this.locale.startsWith('fr') ? 'fr' : 'en') + '/details/' + encodeURIComponent(tracking.number);
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            link.append(this.element('span', 'sh-tracking__sr', ' (' + this.text('new_tab') + ')'));
            item.append(link);
          } else {
            item.append(this.element('span', '', tracking.number));
          }
          numbers.append(item);
        }
        details.append(numbers);
        const milestones = this.element('dl', 'sh-tracking__milestones');
        for (const milestone of card.milestones) {
          if (!this.moment(milestone.at)) continue;
          milestones.append(this.element('dt', '', milestone.label));
          const value = this.element('dd');
          value.append(this.momentNode(milestone.at));
          milestones.append(value);
        }
        details.append(milestones);
        if (!card.trackingNumbers.length && !card.milestones.length) details.append(this.element('p', 'sh-tracking__muted', card.status.message));
        bottom.append(details);
        article.append(bottom);
        return article;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-calculator"] && !Shopify.designMode) return;
  try {
    

  (()=>{
    function initialize(root){
if(root.dataset.ibInitialized)return;root.dataset.ibInitialized='true';
const messages=JSON.parse(root.querySelector('[data-ibead-translations]').textContent);
const t=(key,values={})=>Object.entries(values).reduce((text,[name,value])=>text.split('[['+name+']]').join(String(value)),messages[key]||key);
const projectName=value=>messages['project_'+value]||value;
    const get=id=>root.querySelector('#'+id);
    const all=selector=>Array.from(root.querySelectorAll(selector));
    const length=get('ib-length'),width=get('ib-width'),clasp=get('ib-clasp'),quantity=get('ib-quantity'),spares=get('ib-spares'),svg=get('ib-strand');
    let unit='cm',project='bracelet',colour='#2e3192',count=30,hardware=15,bead=6,lastLengthMm=190;
    const factors={mm:1,cm:10,in:25.4};
    const fmt=(n,d=3)=>Number(n.toFixed(d)).toLocaleString('en-CA',{maximumFractionDigits:d});
    const press=(selector,attribute,value)=>all(selector).forEach(el=>el.setAttribute('aria-pressed',String(el.dataset[attribute]===value)));
    const node=(name,attrs)=>{const el=document.createElementNS('http://www.w3.org/2000/svg',name);Object.entries(attrs).forEach(([k,v])=>el.setAttribute(k,String(v)));return el;};
    function draw(){
      const w=Math.max(220,svg.getBoundingClientRect().width||360),h=284,cx=w/2,cy=h/2,r=Math.min(112,w/2-22);
      svg.setAttribute('viewBox',`0 0 ${w} ${h}`);svg.replaceChildren();
      const safeCount=Number.isFinite(count)&&count>0?count:0;
      svg.setAttribute('aria-label',safeCount?t('m076',{v0:(safeCount),v1:(projectName(project)),v2:(hardware)}):t('m075'));
      if(!safeCount)return;
      const shown=Math.min(safeCount,160),total=safeCount*bead+hardware,rawGap=hardware>0?hardware/total*Math.PI*2:0,gap=Math.max(rawGap,hardware>0?.16:0),available=Math.PI*2-gap,step=available/shown,br=Math.min(13,Math.max(1.4,r*Math.sin(step/2)*.89));
      svg.appendChild(node('circle',{cx,cy,r,fill:'none',stroke:'#d2d4e3','stroke-width':1}));
      for(let i=0;i<shown;i++){
        const a=-Math.PI/2+gap/2+(i+.5)*step,x=cx+r*Math.cos(a),y=cy+r*Math.sin(a);
        svg.appendChild(node('circle',{cx:x,cy:y,r:br,fill:colour,stroke:colour==='#e0b000'?'#9b7300':'none','stroke-width':.7}));
        if(br>4)svg.appendChild(node('circle',{cx:x-br*.25,cy:y-br*.25,r:br*.22,fill:'#ffffff',opacity:.45}));
      }
      if(hardware>0){const a0=-Math.PI/2-gap/2,a1=-Math.PI/2+gap/2,x0=cx+r*Math.cos(a0),y0=cy+r*Math.sin(a0),x1=cx+r*Math.cos(a1),y1=cy+r*Math.sin(a1);svg.appendChild(node('path',{d:`M${x0} ${y0} A${r} ${r} 0 ${gap>Math.PI?1:0} 1 ${x1} ${y1}`,fill:'none',stroke:'#9295a8','stroke-width':4,'stroke-linecap':'round'}));}
      root.querySelector('.ib-previewnote').textContent=safeCount>160?t('m074'):t('m073');
    }
    function update(mmOverride=null){
      const raw=length.value.trim(),b=width.value.trim(),c=clasp.value.trim(),q=quantity.value.trim(),l=Number.isFinite(mmOverride)?mmOverride:Number(raw)*factors[unit],bw=Number(b),cl=Number(c),qty=Number(q);
      if(raw&&Number.isFinite(l)&&l>0&&l<=100000)lastLengthMm=l;
      let error='';
      if(!raw||!Number.isFinite(l)||l<=0||l>100000)error=t('m072');
      else if(!b||!Number.isFinite(bw)||bw<.1||bw>100)error=t('m071');
      else if(!c||!Number.isFinite(cl)||cl<0||cl>=l)error=t('m070');
      else if(!q||!Number.isInteger(qty)||qty<1||qty>10000)error=t('m069');
      const e=get('ib-error');e.hidden=!error;e.textContent=error;
      press('[data-size]','size',String(bw));
      if(error){count=0;get('ib-count').textContent='—';get('ib-total').textContent=t('m068');get('ib-breakdown').textContent='';get('ib-actual').textContent='—';draw();return;}
      lastLengthMm=l;bead=bw;hardware=cl;const rawCount=(l-cl)/bw;count=Math.max(1,Math.ceil(rawCount-1e-9*Math.max(1,rawCount)));
      const base=count*qty,extra=spares.checked?Math.ceil(base*.1-1e-10):0,actual=(count*bw+cl)/factors[unit];
      get('ib-count').textContent=fmt(count,0);get('ib-per-piece').textContent=t('m067')+projectName(project);
      get('ib-total').textContent=fmt(base+extra,0)+t('m066');get('ib-breakdown').textContent=qty===1?t('m065',{v0:(fmt(base,0)),v1:(extra?' + '+fmt(extra,0)+t('m064'):'')}):t('m063',{v0:(fmt(qty,0)),v1:(fmt(count,0)),v2:(extra?' + '+fmt(extra,0)+t('m064'):'')});
      get('ib-actual').textContent=fmt(actual,2)+' '+unit;draw();
    }
    all('[data-tool]').forEach(button=>button.addEventListener('click',()=>{const tool=button.dataset.tool;press('[data-tool]','tool',tool);['plan','convert','fractions'].forEach(id=>get('ib-'+id).hidden=id!==tool);if(tool==='plan')draw();}));
    all('[data-project]').forEach(button=>button.addEventListener('click',()=>{project=button.dataset.project;press('[data-project]','project',project);const presets={bracelet:190,necklace:457.2,custom:300};lastLengthMm=presets[project];get('ib-preset').value=project==='necklace'?'18':'';length.value=Number((lastLengthMm/factors[unit]).toFixed(8));update(lastLengthMm);}));
    get('ib-preset').addEventListener('change',()=>{if(!get('ib-preset').value)return;const inches=Number(get('ib-preset').value);project=inches===7?'bracelet':'necklace';press('[data-project]','project',project);lastLengthMm=inches*25.4;length.value=Number((lastLengthMm/factors[unit]).toFixed(8));update(lastLengthMm);});
    length.addEventListener('input',()=>{get('ib-preset').value='';});
    all('[data-unit]').forEach(button=>button.addEventListener('click',()=>{const valid=length.value.trim()!==''&&Number.isFinite(Number(length.value))&&Number(length.value)>0;unit=button.dataset.unit;length.max=String(100000/factors[unit]);press('[data-unit]','unit',unit);get('ib-length-unit').textContent=unit;if(valid){length.value=Number((lastLengthMm/factors[unit]).toFixed(8));update(lastLengthMm);}else update();}));
    all('[data-size]').forEach(button=>button.addEventListener('click',()=>{width.value=button.dataset.size;update();}));
    all('[data-colour]').forEach(button=>button.addEventListener('click',()=>{colour=button.dataset.colour;press('[data-colour]','colour',colour);draw();}));
    [length,width,clasp,quantity,spares].forEach(el=>el.addEventListener('input',update));
    get('ib-reset').addEventListener('click',()=>{unit='cm';project='bracelet';colour='#2e3192';lastLengthMm=190;length.value='19';width.value='6';clasp.value='15';quantity.value='1';spares.checked=true;get('ib-preset').value='';get('ib-length-unit').textContent='cm';press('[data-unit]','unit',unit);press('[data-project]','project',project);press('[data-colour]','colour',colour);update();});
    const categories={
      length:{units:[['mm',t('m062'),'mm',.001],['cm',t('m061'),'cm',.01],['m',t('m060'),'m',1],['km',t('m059'),'km',1000],['in',t('m058'),'in',.0254],['ft',t('m057'),'ft',.3048],['yd',t('m056'),'yd',.9144],['mi',t('m055'),'mi',1609.344]],from:'in',to:'cm',value:'7.5',help:t('m054'),refs:[t('m053'),t('m052'),t('m051')]},
      weight:{units:[['mg',t('m050'),'mg',.000001],['g',t('m049'),'g',.001],['kg',t('m048'),'kg',1],['oz',t('m047'),'oz',.028349523125],['lb',t('m046'),'lb',.45359237],['t',t('m045'),'t',1000]],from:'oz',to:'g',value:'1',help:t('m044'),refs:[t('m043'),t('m042'),t('m041')]},
      area:{units:[['mm2',t('m040'),'mm²',.000001],['cm2',t('m039'),'cm²',.0001],['m2',t('m038'),'m²',1],['km2',t('m037'),'km²',1000000],['ac',t('m036'),'ac',4046.8564224],['ha',t('m035'),'ha',10000]],from:'cm2',to:'mm2',value:'1',help:t('m034'),refs:[t('m033'),t('m032'),t('m031')]},
      temperature:{units:[['c',t('m030'),'°C'],['f',t('m029'),'°F'],['k',t('m028'),'K']],from:'c',to:'f',value:'20',help:t('m027'),refs:['0 °C = 32 °F','100 °C = 212 °F','0 °C = 273.15 K']},
      time:{units:[['s',t('m026'),'s',1],['min',t('m025'),'min',60],['h',t('m024'),'h',3600],['d',t('m023'),t('m022'),86400],['wk',t('m021'),t('m020'),604800],['yr',t('m019'),t('m018'),31536000]],from:'h',to:'min',value:'1',help:t('m017'),refs:[t('m016'),t('m015'),t('m014')]}
    };
    let category='length';
    const conversionStates={};
    const cv=get('ib-convert-value'),cf=get('ib-convert-from'),ct=get('ib-convert-to');
    const numberText=n=>{if(Object.is(n,-0)||n===0)return '0';const clean=Number(n.toPrecision(10));return Math.abs(clean)>=1e10||Math.abs(clean)<1e-7?clean.toExponential():clean.toLocaleString('en-CA',{maximumSignificantDigits:10});};
    function convert(){
      const v=Number(cv.value),settings=categories[category],from=settings.units.find(u=>u[0]===cf.value),to=settings.units.find(u=>u[0]===ct.value);
      let error='',result;
      if(!cv.value.trim()||!Number.isFinite(v))error=t('m013');
      else if(category!=='temperature'&&v<0)error=t('m012');
      if(!error){
        if(category==='temperature'){
          const c=from[0]==='c'?v:from[0]==='f'?(v-32)*5/9:v-273.15;
          if(c < -273.15-1e-9)error=t('m011');
          result=from[0]===to[0]?v:to[0]==='c'?c:to[0]==='f'?c*9/5+32:c+273.15;
          if(Math.abs(result)<1e-12)result=0;
        }else result=from[0]===to[0]?v:v*from[3]/to[3];
        if(!Number.isFinite(result))error=t('m010');
      }
      get('ib-convert-error').hidden=!error;get('ib-convert-error').textContent=error;
      cv.setAttribute('aria-invalid',String(Boolean(error)));
      get('ib-converted').textContent=error?'—':numberText(result);
      get('ib-conversion-equation').textContent=error?t('m009'):`${numberText(v)} ${from[2]} = ${numberText(result)} ${to[2]}`;
      conversionStates[category]={value:cv.value,from:cf.value,to:ct.value};
    }
    function setCategory(next){
      category=next;press('[data-category]','category',category);
      const settings=categories[category],state=conversionStates[category]||settings;
      [cf,ct].forEach(select=>{select.replaceChildren();settings.units.forEach(([id,label,symbol])=>{const option=document.createElement('option');option.value=id;option.textContent=label+' ('+symbol+')';select.appendChild(option);});});
      cf.value=state.from;ct.value=state.to;cv.value=state.value;
      if(category==='temperature')cv.removeAttribute('min');else cv.min='0';
      get('ib-conversion-help').textContent=settings.help;
      get('ib-reference').replaceChildren();settings.refs.forEach(ref=>{const el=document.createElement('strong');el.textContent=ref;get('ib-reference').appendChild(el);});convert();
    }
    all('[data-category]').forEach(button=>button.addEventListener('click',()=>setCategory(button.dataset.category)));
    [cv,cf,ct].forEach(el=>el.addEventListener('input',convert));
    get('ib-swap').addEventListener('click',()=>{const previous=cf.value;cf.value=ct.value;ct.value=previous;convert();});
    const gcd=(a,b)=>b?gcd(b,a%b):a;
    const fixedFour=n=>(Math.round(n*10000+1e-7)/10000).toFixed(4);
    const picker=get('ib-frac-picker'),ruler=get('ib-fraction-ruler'),rulerSlider=get('ib-ruler-slider'),fractionRows=[];
    let selectedFraction=32,fractionRange=0,fractionFormat='fraction';
    function fractionText(i){const whole=Math.floor(i/64),rem=i%64,div=gcd(rem,64);return rem?(whole?whole+'-':'')+(rem/div)+'/'+(64/div):String(whole);}
    for(let i=1;i<=192;i++){
      const fraction=fractionText(i),decimal=fixedFour(i/64),mm=fixedFour(i*254/640);
      const button=document.createElement('button');button.type='button';button.className='ib-frac-option cursor-interaction';button.textContent=fraction+'″';button.dataset.fraction=String(i);button.dataset.common=String(i%8===0);button.setAttribute('aria-pressed',String(i===selectedFraction));button.setAttribute('aria-label',t('m008',{v0:(fraction.replace('-',t('m007'))),v1:(decimal),v2:(mm)}));button.addEventListener('click',()=>selectFraction(i));picker.appendChild(button);fractionRows.push({button,index:i,fraction,decimal,mm});
    }
    function setFractionFormat(format){
      fractionFormat=format;
      picker.dataset.format=format;
      press('[data-frac-format]','fracFormat',format);
      fractionRows.forEach(row=>{
        row.button.textContent=format==='mm'?row.mm+' mm':(format==='decimal'?row.decimal:row.fraction)+'″';
      });
    }
    all('[data-frac-format]').forEach(button=>button.addEventListener('click',()=>setFractionFormat(button.dataset.fracFormat)));
    function drawRuler(){
      const w=Math.max(200,ruler.getBoundingClientRect().width||800),start=8,end=w-8,span=end-start,relative=selectedFraction-fractionRange*64,pos=start+span*relative/64;
      ruler.setAttribute('viewBox',`0 0 ${w} 94`);ruler.replaceChildren();
      ruler.appendChild(node('rect',{x:start,y:16,width:span,height:18,rx:3,fill:'#e2e3f0'}));
      ruler.appendChild(node('rect',{x:start,y:16,id:'ib-ruler-fill',width:Math.max(0,pos-start),height:18,rx:3,fill:'#2e3192'}));
      for(let i=0;i<=64;i++){
        const x=start+span*i/64,tall=i%16===0?24:i%8===0?17:i%4===0?12:i%2===0?8:5;
        ruler.appendChild(node('line',{x1:x,x2:x,y1:39,y2:39+tall,stroke:i%8===0?'#646780':'#b6b8ce','stroke-width':1}));
      }
      const labelTicks=w<480?[0,32,64]:[0,16,32,48,64];
      labelTicks.forEach(i=>{const label=node('text',{x:start+span*i/64,y:84,'text-anchor':i===0?'start':i===64?'end':'middle',fill:'#606277','font-size':12,'font-family':'Lato,Arial,sans-serif'});label.textContent=fractionText(fractionRange*64+i)+'″';ruler.appendChild(label);});
      ruler.appendChild(node('line',{id:'ib-ruler-marker',x1:pos,x2:pos,y1:9,y2:65,stroke:'#2e3192','stroke-width':2}));ruler.appendChild(node('circle',{id:'ib-ruler-dot',cx:pos,cy:8,r:4,fill:'#2e3192'}));
    }
    function updateRulerMeasurement(i){
      selectedFraction=Math.max(fractionRange*64,Math.min((fractionRange+1)*64,i));
      const fraction=fractionText(selectedFraction),decimal=fixedFour(selectedFraction/64),mm=fixedFour(selectedFraction*254/640);
      get('ib-frac-result').textContent=fraction+'″';get('ib-frac-decimal').textContent=decimal;get('ib-frac-mm').textContent=mm;
      rulerSlider.min=String(fractionRange*64);rulerSlider.max=String((fractionRange+1)*64);rulerSlider.value=String(selectedFraction);
      rulerSlider.setAttribute('aria-valuetext',t('m008',{v0:fraction.replace('-',t('m007')),v1:decimal,v2:mm}));
      press('[data-fraction]','fraction',String(selectedFraction));
      const span=ruler.viewBox.baseVal.width-16,pos=8+span*(selectedFraction-fractionRange*64)/64;
      const fill=get('ib-ruler-fill'),marker=get('ib-ruler-marker'),dot=get('ib-ruler-dot');
      if(fill)fill.setAttribute('width',String(Math.max(0,pos-8)));
      if(marker){marker.setAttribute('x1',String(pos));marker.setAttribute('x2',String(pos));}
      if(dot)dot.setAttribute('cx',String(pos));
    }
    function selectFraction(i){
      fractionRange=Math.max(0,Math.floor((i-1)/64));
      updateRulerMeasurement(i);press('[data-frac-range]','fracRange',String(fractionRange));searchFractions();drawRuler();
    }
    rulerSlider.addEventListener('input',()=>updateRulerMeasurement(Number(rulerSlider.value)));
    function searchFractions(){
      const raw=get('ib-fraction-search').value.toLowerCase().trim();
      const mmOnly=/\bmm\b|millimet/.test(raw),inchOnly=/inches|inch|\bin\b|[″"]/.test(raw);
      const aliases={'⅛':'1/8','¼':'1/4','⅜':'3/8','½':'1/2','⅝':'5/8','¾':'3/4','⅞':'7/8'};
      const term=raw.replace(/(\d)([⅛¼⅜½⅝¾⅞])/g,'$1 $2').replace(/[⅛¼⅜½⅝¾⅞]/g,m=>aliases[m]).replace(/millimet(?:er|re)s?|inches|inch|\bmm\b|\bin\b|[″"]/g,'').trim().replace(/\s*\/\s*/g,'/').replace(/^(\d+)\s+(\d+\/\d+)$/,'$1-$2');
      let matches=0;
      fractionRows.forEach(row=>{const fields=mmOnly?[row.mm]:inchOnly?[row.fraction,row.decimal]:[row.fraction,row.decimal,row.mm];const exactMillimetres=mmOnly&&Number.isFinite(Number(term));const visible=term?(exactMillimetres?Number(row.mm)===Number(term):fields.some(value=>value.includes(term))):Math.floor((row.index-1)/64)===fractionRange;row.button.hidden=!visible;if(visible)matches++;});
      get('ib-picker-title').textContent=term?t('m005'):fractionRange===0?t('m004'):t('m003',{v0:(fractionRange),v1:(fractionRange+1)});
      get('ib-fraction-count').textContent=term?t('m002',{v0:(matches)}):t('m001');get('ib-no-matches').hidden=matches!==0;
    }
    all('[data-frac-range]').forEach(button=>button.addEventListener('click',()=>{const offset=selectedFraction-fractionRange*64;fractionRange=Number(button.dataset.fracRange);get('ib-fraction-search').value='';updateRulerMeasurement(fractionRange*64+offset);press('[data-frac-range]','fracRange',String(fractionRange));searchFractions();drawRuler();}));
    get('ib-fraction-search').addEventListener('input',searchFractions);
    get('ib-clear-search').addEventListener('click',()=>{get('ib-fraction-search').value='';searchFractions();get('ib-fraction-search').focus();});
    if(typeof ResizeObserver!=='undefined'){new ResizeObserver(draw).observe(svg);new ResizeObserver(drawRuler).observe(ruler);}
    update();setCategory('length');selectFraction(32);setFractionFormat('fraction');
}
function initializeAll(){document.querySelectorAll('[data-ibead-calculator]').forEach(initialize);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initializeAll);else initializeAll();
document.addEventListener('shopify:section:load',initializeAll);
  })();
  

  } catch(e) { console.error(e); }
})();
})();
